import R from 'app/assets/R'
import { BaseSpace } from 'app/components/common/BaseSpace'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import React, { useEffect, useMemo } from 'react'
import { useHook } from './hook'
import { CreateModalLayout, FilterLayout } from './layouts'
import * as S from './styles'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import { PermissionEnum } from 'app/common/enum'
import { BaseCol } from 'app/components/common/BaseCol'
import BaseText from 'app/components/common/BaseText'

const RoleManagementContainer: React.FC = () => {
  const {
    columns,
    dataTable,
    handleTableChange,
    isLoading,
    pagination,
    filter,
    onChangeFilter,
    downloadExcel,
  } = useHook()

  const { user, verifyPermissionAndRedirect, verifyPermission } =
    useVerifyPermission()

  useEffect(() => {
    verifyPermissionAndRedirect(PermissionEnum.ReadRole)
  }, [user])

  const isCreateRole = useMemo(() => {
    return verifyPermission(PermissionEnum.CreateRole)
  }, [user])

  return (
    <S.ScrollWrapper>
      <HeaderPage
        titleI18nKey={R.strings.role_management}
        rightComponent={
          isCreateRole ? (
            <BaseCol>
              <CreateModalLayout />
            </BaseCol>
          ) : null
        }
        isExport={verifyPermission(PermissionEnum.ExportRole)}
        onPressExport={downloadExcel}
      />

      <SectionBase>
        <BaseSpace size={0}>
          <FilterLayout filter={filter} onChangeFilter={onChangeFilter} />
          <BaseTableManagement
            pagination={{
              ...pagination,
              total: pagination.total,
              showTotal: total => (
                <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
              ),
              showSizeChanger: true,
            }}
            columns={columns}
            dataSource={dataTable}
            onChange={handleTableChange}
            loading={isLoading}
          />
        </BaseSpace>
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default RoleManagementContainer
